import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { ContainersActions } from '../StoreAdapter'
import { ContainerSchema } from '../../../Schema/ContainerSchema'
import { ServiceLocator } from '../../../Services/ServiceLocator'
import { ContainersAPI } from '../../../Services/API/ContainersAPI'

export const useAddContainer = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const addContainer = useCallback(
    async (schema: ContainerSchema): Promise<ContainerSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(ContainersAPI)
        .createEntity(schema)
        .then((schema) => {
          dispatch(ContainersActions.addOne(schema))
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(err.message)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    error,
    errorMessage,
    addContainer,
  }
}
